import React, { useState, useCallback } from 'react';

const PMPMH_LABEL = "PMPMH (PROGRAMA) + RESO. IF-2025-00682339";

const initialOrgDocsData = [
    { id: 1, isChecked: false, name: "Reso. Inscripción Registro ONGs", orden: "", hasVto: false },
    { id: 2, isChecked: false, name: "Acta Constitutiva", orden: "", hasVto: false },
    { id: 3, isChecked: false, name: "Acta Asamblea", orden: "", hasVto: false },
    { id: 4, isChecked: false, name: "Estatuto", orden: "", hasVto: false },
    { id: 5, isChecked: false, name: "DNI Presidente", orden: "", hasVto: false },
    { id: 6, isChecked: false, name: "CBU Organización", orden: "", hasVto: false },
    { id: 7, isChecked: false, name: "Repoc. (Dirección para el convenio)", orden: "", hasVto: true, defaultValueVto: null },
    { id: 8, isChecked: false, name: "ARCA", orden: "", hasVto: true, defaultValueVto: null },
    { id: 9, isChecked: false, name: "Certificado de Vigencia (DPPJ)", orden: "", hasVto: true, defaultValueVto: null },
    { id: 10, isChecked: false, name: "INAES (Si es cooperativa)", orden: "", hasVto: false },
];

const initialProjectDocsData = [
    { id: 1, isChecked: false, name: "Nota de Solicitud", orden: "" },
    { id: 2, isChecked: false, name: "Proyecto", orden: "" },
    { id: 3, isChecked: false, name: "Reso. Barrios", orden: "" },
    { id: 4, isChecked: false, name: "Reso. Gral. De Barrios: RESO 2020-38-GDEBA-SSHCMDCGP (Vínculo Con Num. Especial) + IF-2020-18603038-GDEBA-DRYOMDCGP (Anexo De La RS. 38. Vínculo Con Un GDEBA Separado De La RS.)", orden: "" },
    { id: 5, isChecked: false, name: "Modelo De Convenio (IF.)", orden: "" },
    { id: 6, isChecked: false, name: "Reso. De Proyecto (PRESO.)", orden: "" },
];

const initialPvData = [
    { id: 1, isChecked: false, name: "PV. Miryam (se genera y carga al expte.)", orden: "" },
    { id: 2, isChecked: false, name: "PV. Érica (carga al expte. y pase a Érica)", orden: "" },
    { id: 3, isChecked: false, name: "PV. Lucas (por wpp.)", orden: "" },
];

const mergeData = (saved, defaults) => {
    if (!saved || saved.length === 0) return defaults;
    return defaults.map(def => {
        const found = saved.find(s => s.item_id === def.id);
        if (found) {
            return { ...def, isChecked: found.isChecked, orden: found.orden, fecha_vencimiento: found.fecha_vencimiento || def.defaultValueVto || null };
        }
        return def;
    });
};

const toFlat = (seccion, items, orgDocsExpanded) =>
    items.map(item => ({
        seccion,
        item_id: item.id,
        name: item.name,
        isChecked: item.isChecked,
        orden: item.orden,
        fecha_vencimiento: item.defaultValueVto || item.fecha_vencimiento || null,
        org_docs_expanded: orgDocsExpanded
    }));

const inputClasses = "w-full text-xs p-1 text-center rounded border border-gray-300 dark:bg-gray-700 dark:text-white dark:border-gray-600 focus:outline-none focus:ring-1 focus:ring-blue-500";
const dateClasses = "w-full text-xs p-1 rounded border border-gray-300 dark:bg-gray-700 dark:text-white dark:border-gray-600 focus:outline-none focus:ring-1 focus:ring-blue-500";

const ItemRow = ({ item, onToggleCheck, onInputChange, onDateChange, showVtoColumn, disabled }) => (
    <div className="flex items-center gap-2 py-1.5 border-b border-gray-100 last:border-b-0">
        <input
            type="checkbox"
            checked={item.isChecked}
            onChange={() => onToggleCheck(item.id)}
            disabled={disabled}
            className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500 disabled:opacity-50 shrink-0"
        />
        <div className="flex-grow text-xs text-gray-700 dark:text-gray-200 leading-tight">{item.name}</div>
        {showVtoColumn && item.hasVto && (
            <div className="w-28 shrink-0">
                <input
                    type="date"
                    value={item.fecha_vencimiento || item.defaultValueVto || ''}
                    onChange={(e) => onDateChange(item.id, e.target.value)}
                    disabled={disabled}
                    className={dateClasses + " disabled:opacity-50"}
                />
            </div>
        )}
        <div className="w-14 shrink-0">
            <input
                type="text"
                value={item.orden}
                onChange={(e) => onInputChange(item.id, 'orden', e.target.value)}
                disabled={disabled}
                className={inputClasses + " disabled:opacity-50"}
                placeholder="Ord."
            />
        </div>
    </div>
);

const ExpedienteProyecto = ({ inicial, onChange, disabled = false, expanded }) => {
    const initialOrgDocs = mergeData(inicial?.orgDocs, initialOrgDocsData);
    const [showOrgDocs, setShowOrgDocs] = useState(
        () => expanded !== undefined ? expanded : initialOrgDocs.some(d => d.isChecked)
    );

    const orgDocs = initialOrgDocs;
    const projectDocs = mergeData(inicial?.projectDocs, initialProjectDocsData);
    const pv = mergeData(inicial?.pv, initialPvData);

    const emitChange = useCallback((sectionKey, items) => {
        if (!onChange) return;
        onChange({
            orgDocs: sectionKey === 'orgDocs' ? items : orgDocs,
            projectDocs: sectionKey === 'projectDocs' ? items : projectDocs,
            pv: sectionKey === 'pv' ? items : pv,
            orgDocsExpanded: showOrgDocs,
        });
    }, [onChange, orgDocs, projectDocs, pv, showOrgDocs]);

    const handleInputChange = (sectionKey, sectionData, id, field, value) => {
        const updated = sectionData.map(item =>
            item.id === id ? { ...item, [field]: value } : item
        );
        emitChange(sectionKey, updated);
    };

    const handleToggleCheck = (sectionKey, sectionData, id) => {
        const updated = sectionData.map(item =>
            item.id === id ? { ...item, isChecked: !item.isChecked } : item
        );
        emitChange(sectionKey, updated);
    };

    const handleDateChange = (sectionKey, sectionData, id, value) => {
        const updated = sectionData.map(item =>
            item.id === id ? { ...item, fecha_vencimiento: value } : item
        );
        emitChange(sectionKey, updated);
    };

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
                {/* Línea Amarilla de Caratulación */}
                <div>
                    {/*<h5 className="text-md font-semibold mb-3 text-gray-700">Línea Amarilla de Caratulación</h5>*/}
                    <div className="p-2 border rounded dark:border-gray-600 bg-white dark:bg-gray-800">
                        <p className="text-xs text-gray-600 dark:text-gray-300 font-medium">{PMPMH_LABEL}</p>
                    </div>
                </div>

                {/* Documentación Organización */}
                <div>
                    <div className="flex items-center gap-2 mb-2">
                        <input
                            type="checkbox"
                            checked={showOrgDocs}
                            onChange={() => {
                                const newVal = !showOrgDocs;
                                setShowOrgDocs(newVal);
                                if (onChange) {
                                    onChange({ orgDocs, projectDocs, pv, orgDocsExpanded: newVal });
                                }
                            }}
                            className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                        />
                        <h5 className="text-md font-semibold text-gray-700" onClick={() => {
                            const newVal = !showOrgDocs;
                            setShowOrgDocs(newVal);
                            if (onChange) {
                                onChange({ orgDocs, projectDocs, pv, orgDocsExpanded: newVal });
                            }
                        }}>
                            Documentación Organización
                        </h5>
                        <span className="text-xs text-gray-400 italic">(Tildar para ver detalles)</span>
                    </div>
                    {showOrgDocs && (
                        <div className="space-y-2 p-2 border rounded dark:border-gray-600 bg-white dark:bg-gray-800 max-h-[400px] overflow-y-auto">
                            {orgDocs.map((doc) => (
                                <ItemRow
                                    key={doc.id}
                                    item={doc}
                                    onToggleCheck={(id) => handleToggleCheck('orgDocs', orgDocs, id)}
                                    onInputChange={(id, field, value) => handleInputChange('orgDocs', orgDocs, id, field, value)}
                                    onDateChange={(id, value) => handleDateChange('orgDocs', orgDocs, id, value)}
                                    showVtoColumn={true}
                                    disabled={disabled}
                                />
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="space-y-4">
                {/* Proyecto */}
                <div>
                    <h5 className="text-md font-semibold mb-3 text-gray-700">Proyecto</h5>
                    <div className="space-y-2 p-2 border rounded dark:border-gray-600 bg-white dark:bg-gray-800 max-h-[400px] overflow-y-auto">
                        {projectDocs.map((doc) => (
                            <ItemRow
                                key={doc.id}
                                item={doc}
                                onToggleCheck={(id) => handleToggleCheck('projectDocs', projectDocs, id)}
                                onInputChange={(id, field, value) => handleInputChange('projectDocs', projectDocs, id, field, value)}
                                onDateChange={(id, value) => handleDateChange('projectDocs', projectDocs, id, value)}
                                showVtoColumn={false}
                                disabled={disabled}
                            />
                        ))}
                    </div>
                </div>

                {/* Providencias */}
                <div>
                    <h5 className="text-md font-semibold mb-3 text-gray-700">Providencias</h5>
                    <div className="space-y-2 p-2 border rounded dark:border-gray-600 bg-white dark:bg-gray-800 max-h-[400px] overflow-y-auto">
                        {pv.map((pvItem) => (
                            <ItemRow
                                key={pvItem.id}
                                item={pvItem}
                                onToggleCheck={(id) => handleToggleCheck('pv', pv, id)}
                                onInputChange={(id, field, value) => handleInputChange('pv', pv, id, field, value)}
                                onDateChange={(id, value) => handleDateChange('pv', pv, id, value)}
                                showVtoColumn={false}
                                disabled={disabled}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExpedienteProyecto;
export { toFlat, initialOrgDocsData, initialProjectDocsData, initialPvData };
